import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  /* should be refactor to one wrapper. using multiple places */
  padding: 10px 12px;
  height: 64px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  /* should be refactor to one wrapper. using multiple places */
`;

export const iconCommonStyles = css`
  color: ${(props) => props.theme.common.subHeadingColor};
`;

export const IconsWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const AttachButton = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: ${(props) => props.theme.common.secondaryColor};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);

  .icon {
    ${iconCommonStyles}
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 52px;
`;

export const Button = styled.button<{ readonly showIcon: boolean }>`
  transform: ${(props) => (props.showIcon ? "scale(1)" : "scale(0)")};
  opacity: ${(props) => (props.showIcon ? 1 : 0)};
  transition: all 0.5s ease;
  margin-bottom: 10px;

  &:nth-of-type(1) {
    transition-delay: 0.25s;
  }

  &:nth-of-type(2) {
    transition-delay: 0.2s;
  }

  &:nth-of-type(3) {
    transition-delay: 0.15s;
  }

  &:nth-of-type(4) {
    transition-delay: 0.1s;
  }

  &:nth-of-type(5) {
    transition-delay: 0.05s;
  }
`;

export const InputWrapper = styled.div`
  flex: 1;
  height: 42px;
  display: flex;
  align-items: center;
  background: ${(props) => props.theme.common.secondaryColor};
  border-radius: 999px;
  padding: 0 12px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.05);
`;

export const Input = styled.input`
  background: transparent;
  color: ${(props) => props.theme.common.mainHeadingColor};
  border: none;
  flex: 1;
  height: 100%;
  font-size: 0.95rem;
  direction: rtl;
  text-align: right;

  &::placeholder {
    color: ${(props) => props.theme.common.subHeadingColor};
  }

  &:focus {
    outline: none;
  }
`;

export const EmojiButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: grid;
  place-items: center;

  .icon {
    ${iconCommonStyles}
  }
`;

export const SendMessageButton = styled.button`
  .icon {
    margin-left: 8px;
    margin-right: 8px;
    width: 28px;
    height: 28px;
    padding: 3px;
    border-radius: 50%;
    ${iconCommonStyles}
  }
`;

export const MicButton = styled.button`
  .icon {
    width: 28px;
    height: 28px;
    padding: 3px;
    border-radius: 50%;
    ${iconCommonStyles}
  }
`;
